/* global ga Raven */
import offline from 'offline-plugin/runtime'

if (process.env.NODE_ENV === 'production') {
	offline.install({
		onUpdateReady: () => offline.applyUpdate(),
		onUpdated: () => window.location.reload(),
	})

	Raven.config(process.config.sentry).install()
}

const dimensions = {
	VIEW_MODE: 'dimension1',
}

const metrics = {
	RESPONSE_END_TIME: 'metric1',
	DOM_LOAD_TIME: 'metric2',
	WINDOW_LOAD_TIME: 'metric3',
}

window.ga = window.ga || ((...args) => (ga.q = ga.q || []).push(args))
ga('create', process.config.analytics, 'auto')
ga('set', 'transport', 'beacon')
ga('send', 'pageview')

if (navigator.standalone) {
	ga('set', dimensions.VIEW_MODE, 'Home Screen')
}

const sendNavigationTimingMetrics = () => {
	// Only track performance in supporting browsers.
	if (!(window.performance && window.performance.timing)) return

	// If the window hasn't loaded, run this function after the `load` event.
	if (document.readyState !== 'complete') {
		window.addEventListener('load', sendNavigationTimingMetrics)
		return
	}

	const nt = performance.timing
	const navStart = nt.navigationStart

	const responseEnd = Math.round(nt.responseEnd - navStart)
	const domLoaded = Math.round(nt.domContentLoadedEventStart - navStart)
	const windowLoaded = Math.round(nt.loadEventStart - navStart)

	// In some edge cases browsers return very obviously incorrect NT values,
	// e.g. 0, negative, or future times. This validates values before sending.
	const allValuesAreValid = (...values) => (
		values.every((value) => value > 0 && value < 1e6)
	)

	if (allValuesAreValid(responseEnd, domLoaded, windowLoaded)) {
		ga('send', 'event', {
			eventCategory: 'Navigation Timing',
			eventAction: 'track',
			nonInteraction: true,
			[metrics.RESPONSE_END_TIME]: responseEnd,
			[metrics.DOM_LOAD_TIME]: domLoaded,
			[metrics.WINDOW_LOAD_TIME]: windowLoaded,
		})
	}
}

sendNavigationTimingMetrics()



// WEBPACK FOOTER //
// ./src/entry.js